
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

// Lazy-load non-critical CSS 
const loadNonCriticalCSS = () => {
  // This could be used to load additional CSS resources after initial render
  const links = [
    // Add any external non-critical CSS resources here
  ];
  
  links.forEach(href => {
    if (href) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      document.head.appendChild(link);
    }
  });
};

// Add preconnect for important domains
const addPreconnects = () => {
  const domains = [
    'https://kcsydqftkfhmyewxtvgd.supabase.co',
    'https://fonts.googleapis.com',
    'https://fonts.gstatic.com'
  ];
  
  domains.forEach(domain => {
    const link = document.createElement('link');
    link.rel = 'preconnect';
    link.href = domain;
    link.crossOrigin = 'anonymous';
    document.head.appendChild(link);
  });
};

// Add favicon if needed
const addFavicon = () => {
  if (!document.querySelector('link[rel="icon"]')) {
    const link = document.createElement('link');
    link.rel = 'icon';
    link.type = 'image/png';
    link.href = '/lovable-uploads/725d4a82-6ca0-4e39-8b72-3e42aff89638.png';
    document.head.appendChild(link);
  }
};

// Run initial optimizations
addPreconnects();
addFavicon();

// Render the app immediately with proper React context
const rootElement = document.getElementById("root");
if (!rootElement) throw new Error('Root element not found');

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Load non-critical resources after app is rendered
window.addEventListener('load', () => {
  // Schedule non-critical work after the page is loaded
  setTimeout(() => {
    loadNonCriticalCSS();
    
    // Register service worker for caching
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/service-worker.js').catch(err => {
        console.error('ServiceWorker registration failed:', err);
      });
    }
  }, 1000);
});
